import type { Variation } from '@shared/types/types.ts';
import type { DefaultLayout } from '@tilelist/layouts/default-layout/DefaultLayout.ts';
import { getLayoutImages } from '@tilelist/layouts/mapping/LayoutImages.ts';
import { mapLink } from '@tilelist/layouts/mapping/ProductLink.ts';
import { mapShortTitle } from '@tilelist/layouts/mapping/ProductTitle.ts';

export type { DefaultLayout } from '@tilelist/layouts/default-layout/DefaultLayout.ts';

export function createDefaultLayout(
    variation: Variation,
    showTopInfos: boolean,
    showMultipleSizes: boolean,
): DefaultLayout {
    const patchedVariation: Variation = {
        ...variation,
        topInfos: showTopInfos && variation.topInfos?.length ? variation.topInfos : undefined,
        multipleSizes: showMultipleSizes && !!variation.multipleSizes,
    };
    const { images, primaryImage } = getLayoutImages(variation);
    return {
        variation: patchedVariation,
        title: mapShortTitle(variation),
        link: mapLink(variation),
        images,
        primaryImage,
    };
}
